import React from "react";
import { useMutation } from "react-query";
import { getOfficeByOfficeId } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetOfficeForEdit = () => {
  return useMutation(getOfficeByOfficeId);
};

export default useGetOfficeForEdit;
